import { memo, useCallback, useRef } from "react";
import { useState } from "react";
import FileUploadBtnContainer from "../../containers/FileUploadBtn";
import { FormWrapper, StyledForm, SubmitButton, ButtonGroup } from "./style";

const CardAddForm = memo((props) => {
  const { onAddOrUpdate } = props;
  const nameRef = useRef();
  const companyRef = useRef();
  const themeRef = useRef();
  const titleRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();
  const formRef = useRef();

  const [file, setFile] = useState({ fileName: null, filePath: null });

  // useCallback => useEffect 에서 deps 배열에 넣어야함
  const handleFileChange = useCallback((result) => {
    setFile({ fileName: result.name, filePath: result.url });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const newCard = {
      id: Date.now(),
      name: nameRef.current.value || "",
      company: companyRef.current.value || "",
      theme: themeRef.current.value,
      title: titleRef.current.value || "",
      email: emailRef.current.value || "",
      message: messageRef.current.value || "",
      fileName: file.fileName || "",
      filePath: file.filePath || "",
    };
    formRef.current.reset();
    setFile({ fileName: null, filePath: null });
    onAddOrUpdate(newCard);
  };

  return (
    <FormWrapper>
      <StyledForm ref={formRef} onSubmit={(event) => event.preventDefault()}>
        <input
          ref={nameRef}
          type="text"
          name="name"
          placeholder="이름"
          maxLength="8"
        />
        <input
          ref={companyRef}
          type="text"
          name="company"
          placeholder="회사(소속)"
          maxLength="8"
        />
        <select ref={themeRef} name="theme" placeholder="theme">
          <option value="light">light</option>
          <option value="dark">dark</option>
        </select>
        <input
          ref={titleRef}
          type="text"
          name="title"
          placeholder="직업"
          maxLength="8"
        />
        <input ref={emailRef} type="text" name="email" placeholder="이메일" />
        <textarea
          ref={messageRef}
          name="message"
          placeholder="상태 메시지"
          cols="20"
          rows="2"
        ></textarea>
        <ButtonGroup>
          <FileUploadBtnContainer
            onFileChange={handleFileChange}
            fileName={file.fileName}
          />
          <SubmitButton btnType="Add" type="button" onClick={handleSubmit}>
            추가하기
          </SubmitButton>
        </ButtonGroup>
      </StyledForm>
    </FormWrapper>
  );
});

export default CardAddForm;
